export default "__VITE_ASSET__BNvfMvjh__"